import React, { useMemo, useState } from 'react';
import { useAppState } from '../../State';
import Buttons from '../Buttons/Buttons';
import PrimaryButton from '../Buttons/PrimaryButton';
import SecondaryButton from '../Buttons/SecondaryButton';
import { FlowNode, NodeId } from '../../Types/Types';
import VerticalOption from './VerticalOption';

import './ContentOptionStep.less';
import HorizontalOption from './HorizontalOption';

type ContentOptionStep = {
  node: FlowNode;
};

const ContentOptionStep = ({ node }: ContentOptionStep) => {
  const { answers, rearMountedChildBikeSeatsData, selectOption, isConfirmedFitStep, resetFlow } = useAppState();
  const cmsStep = rearMountedChildBikeSeatsData?.Steps?.find((stepData) => stepData.Parameter === node.cmsParameter);
  const translations = rearMountedChildBikeSeatsData?.Translations;
  const [selectedIndex, setSelectedIndex] = useState<number | null>(() => {
    const savedAnswer = node.answerKey ? answers[node.answerKey] : undefined;
    if (!savedAnswer) return null;
    const savedIndex = cmsStep?.ContentOptions?.findIndex((option) => option.NextStep === savedAnswer) ?? -1;
    return savedIndex > -1 ? savedIndex : null;
  });

  const options = useMemo(() => {
    if (!cmsStep?.ContentOptions?.length) {
      return [];
    }
    return cmsStep.ContentOptions.map((option) => ({
      value: option.NextStep,
      label: option.Title,
      nextNodeId: option.NextStep as NodeId,
    }));
  }, [answers, cmsStep?.ContentOptions, node]);

  return (
    <>
      <div className="content-option-selector d-flex flex-column justify-content-center">
        {cmsStep?.ImageUrl && (
          <div className="cms-image-wrapper d-flex justify-content-center w-100 mb-9">
            <img src={cmsStep.ImageUrl} alt={cmsStep.ImageAlt} />
          </div>
        )}
        {cmsStep?.Text && <div dangerouslySetInnerHTML={{ __html: cmsStep.Text }}></div>}
        <hr className="my-5"></hr>
        <div className="options">
          {cmsStep?.ContentOptions?.map((option, index) => {
            return node.cardType === 'vertical' ? (
              <VerticalOption
                option={option}
                selected={selectedIndex === index}
                onClick={() => {
                  setSelectedIndex(index);
                }}
                key={index}
              />
            ) : (
              <HorizontalOption option={option} onClick={() => selectOption(options[index])} key={index} />
            );
          })}
        </div>
      </div>
      {node.cardType === 'vertical' && (
        <Buttons visible>
          <PrimaryButton
            visible
            disabled={selectedIndex === null}
            text={translations?.confirm ?? ''}
            onClick={() => {
              const selected = cmsStep?.ContentOptions?.[selectedIndex ?? 0];
              if (!selected) {
                return;
              }
              selectOption({
                value: selected.NextStep,
                label: selected.NextStep,
              });
            }}
          />
          <SecondaryButton
            visible={isConfirmedFitStep}
            disabled={false}
            text={translations?.reset ?? ''}
            onClick={resetFlow}
          />
        </Buttons>
      )}
    </>
  );
};

export default ContentOptionStep;
